import React, { useState } from 'react';
import styles from './ImageUploadButton.module.scss';
import { FaIcon } from '../Icons.jsx';
import Portal from '../Portal.jsx';
import Dialog, { DialogFooter, DialogHeader } from '../../bootstrap/Dialog.jsx';
import ImageUploader from './ImageUploader.jsx';
import Button from '../../bootstrap/Button.jsx';

function SettingsDialog({InnerComponent, ...props}) {
  return (
    <Dialog {...props}>
      {InnerComponent}
    </Dialog>
  )
}

function ImageUploadButton(props) {
  const { value, loading, onSave = () => {}, hideSaveButton = false, dialogMode = true, onClose = () => {}, onChange = () => {}, closeOnSave = false, closeOnChange = false, nullSaveable = false, label } = props;
  const [open, setOpen] = useState(false);
  const [saveable, setSaveable] = useState(false);

  const handleChange = (val) => {
    setSaveable(!!val);
    if (nullSaveable) {
      setSaveable(true);
    }
    onChange(val);
    if (closeOnChange) handleClose();
  }

  const toggleDialog = () => {
    if (open) {
      onClose();
    }
    setOpen(prev => !prev);
  }

  const handleSave = (val) => {
    onSave(val);
    if (closeOnSave) handleClose();
  }

  const handleClose = () => {
    setOpen(false);
    onClose();
  }

  return (<>
    <button type='button' className={styles['button-block']} onClick={() => setOpen(true)}>
      {label || <><FaIcon type='plus' /> {I18n.t('upload_image')}</>}
    </button>
    <div className={styles['attachment-info']}>
      <div className="d-inline-block text-truncate" style={{fontWeight: 400}}>
        {value?.filename || I18n.t("select_file", { scope: "di" })}
      </div>
    </div>
    {open && dialogMode && <Portal
        component={SettingsDialog}
        /* SettingsDialog props */
        header={<DialogHeader showBorder={true} title={I18n.t('upload_image')} onClose={toggleDialog} />}
        footer={<DialogFooter saveDisabled={!saveable} onAdd={handleSave} onClose={toggleDialog} addText={loading ? I18n.t('loading') : I18n.t('save')} hideSaveButton={hideSaveButton}/>}
        // disabled={loading}
        size='md'
        closeOnOutsideClick={false}
        onClose={toggleDialog}
        InnerComponent={<ImageUploader {...props} onChange={handleChange} />}
    />}
    {open && !dialogMode && <div>
      <ImageUploader {...props} />
      <Button type='default' onClick={toggleDialog}>
        {I18n.t('close')}
      </Button>
    </div>}
  </>)

}

export default ImageUploadButton;